/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friendprofileblockloading3Inputs */



/**
* | output |
* | --- |
* | "Blocking..." |
*
* @param {Friendprofileblockloading3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const friendprofileblockloading3 = /** @type {((inputs?: Friendprofileblockloading3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friendprofileblockloading3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Blocking...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloqueando...")
	return /** @type {LocalizedString} */ ("Блокируем...")
});
export { friendprofileblockloading3 as "friendProfileBlockLoading" }